export default "__VITE_ASSET__425e643c__"